import { isNull, isUndefined, omitBy } from "lodash";

export function removeEmptyProps(obj: object): object {
  return omitBy(obj, (p: string) => isUndefined(p) || isNull(p) || p === "");
}
